import React from 'react';
import { LocalizationContext } from './localization.model';

export const localizationContext = React.createContext<LocalizationContext>(undefined);

/**
 * Access to localization api in context.
 *
 * Localization context depends on language selected. Any language change will
 * trigger new re-render in subscribed components.
 *
 * WARNING: This hook exposes an API only dependant on language, so it will be constant
 * most of the time except a language change is triggered. However, try to avoid using
 * the hook in performant scenarios like in every cell of a dense table. It is better
 * to call useLocalization once in the parent and share whatever method is needed in
 * the children.
 */
export const useLocalization = () => React.useContext(localizationContext);
